<template>
<div class="container mt-5" id="home-top">
  <div class="jumbotron rounded shadow">
    <h1 class="display-4">Send Emails Easily</h1>
    <p class="lead">Sending of Emails in Your Apps and  Websites has never been easier! Our Xend Mail API does it all for you.
      Xend Mail is  completely free JSON API for use in programming projects. All you need is an API Key
    </p>
    <hr class="my-4">
    <p>Useful for  password resets, contact us form, email marketing, email confirmation e.t.c</p>
    <router-link class="btn btn-primary btn-lg mr-1" to="/documentation" role="button">Documentation</router-link>
    <a class="btn btn-primary bg-transparent text-primary btn-lg" href="#try" role="button">Give it a Try</a>
  </div>
</div>
</template>

<script>
export default {
  name: 'Top'

}
</script>

<style scoped>

</style>
